import { createFileRoute } from '@tanstack/react-router'
import { BillingScreen } from '../features/billing'

export const Route = createFileRoute('/billing')({
  validateSearch: (search: Record<string, unknown>): { case?: string } => ({
    case: typeof search.case === 'string' && /^[0-9a-f-]{36}$/i.test(search.case) ? search.case : undefined,
  }),
  component: function BillingRoute() {
    return <BillingScreen focusCase={Route.useSearch().case} />
  },
})
